import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M7 2v11h3v9l7-12h-4l4-8z" />, 'FlashOn');
